import store from '@/store'
function formatTime(time) {
	if (typeof time !== 'number' || time < 0) {
		return time
	}

	let hour = parseInt(time / 3600)
	time = time % 3600
	let minute = parseInt(time / 60)
	time = time % 60
	let second = time

	return ([hour, minute, second]).map(function (n) {
		n = n.toString()
		return n[1] ? n : '0' + n
	}).join(':')
}

function formatLocation(longitude, latitude) {
	if (typeof longitude === 'string' && typeof latitude === 'string') {
		longitude = parseFloat(longitude)
		latitude = parseFloat(latitude)
	}

	longitude = longitude.toFixed(2)
	latitude = latitude.toFixed(2)

	return {
		longitude: longitude.toString().split('.'),
		latitude: latitude.toString().split('.')
	}
}
let dateUtils = {
	UNITS: {
		'年': 31557600000,
		'月': 2629800000,
		'天': 86400000,
		'小时': 3600000,
		'分钟': 60000,
		'秒': 1000
	},
	humanize: function (milliseconds) {
		let humanize = '';
		for (let key in this.UNITS) {
			if (milliseconds >= this.UNITS[key]) {
				humanize = Math.floor(milliseconds / this.UNITS[key]) + key + '前';
				break;
			}
		}
		return humanize || '刚刚';
	},
	format: function (dateStr) {
		let date = this.parse(dateStr)
		let diff = Date.now() - date.getTime();
		if (diff < this.UNITS['天']) {
			return this.humanize(diff);
		}
		let _format = function (number) {
			return (number < 10 ? ('0' + number) : number);
		};
		return date.getFullYear() + '/' + _format(date.getMonth() + 1) + '/' + _format(date.getDate()) + '-' +
			_format(date.getHours()) + ':' + _format(date.getMinutes());
	},
	parse: function (str) { //将"yyyy-mm-dd HH:MM:ss"格式的字符串，转化为一个Date对象
		let a = str.split(/[^0-9]/);
		return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
	}
};

/**
 * 生成随机码
 * @param {Object} length
 */
function getUuid(length){
	if (length > 0) {
      let data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
      let nums = "";
      for (let i = 0; i < length; i++) {
         let r = parseInt(Math.random() * 61);
         nums += data[r];
      }
      return nums;
   } else {
      return false;
   }
}

/**
 * 校验身份证号
 */
function isIDCard(idcode){
	// 加权因子
	let weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
	// 校验码
	let check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

	let code = idcode + "";
	let last = idcode[17];//最后一位

	let seventeen = code.substring(0,17);

	// ISO 7064:1983.MOD 11-2
	// 判断最后一位校验码是否正确
	let arr = seventeen.split("");
	let len = arr.length;
	let num = 0;
	for(let i = 0; i < len; i++){
		num = num + arr[i] * weight_factor[i];
	}
	
	// 获取余数
	let resisue = num%11;
	let last_no = check_code[resisue];

	// 格式的正则
	// 正则思路
	/*
	第一位不可能是0
	第二位到第六位可以是0-9
	第七位到第十位是年份，所以七八位为19或者20
	十一位和十二位是月份，这两位是01-12之间的数值
	十三位和十四位是日期，是从01-31之间的数值
	十五，十六，十七都是数字0-9
	十八位可能是数字0-9，也可能是X
	*/
	let idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

	// 判断格式是否正确
	let format = idcard_patter.test(idcode);

	// 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
	return last === last_no && format ? true : false;
}

function isPoneNumber(phonenum) {
	let myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
	if (!myreg.test(phonenum)) {
		return false;
	} else {
		return true;
	}
}

/**
 * 密码必须包含数字和字母，且长度不小于8位
 * @param password
 * @returns {boolean}
 */
function isPassword(password){
	let pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{8,30}');
	if (!pwdRegex.test(password)) {
		return false;
	}else{
		return true;
	}
}

/**
 * 支持中文格式邮箱
 * @param email
 * @returns {boolean}
 */
function isEmail(email){
	let emailRegex = /^[\u4e00-\u9fa5a-zA-Z\d]+([-_.][\u4e00-\u9fa5A-Za-z\d]+)*@([\u4e00-\u9fa5A-Za-z\d]+[-.]){1,2}[\u4e00-\u9fa5A-Za-z\d]{2,5}$/g;
	if (!emailRegex.test(email)) {
		return false;
	}else{
		return true;
	}
}

/**
 * 打开外连接
 * @param {Object} email
 */
function windowOpen(url){
	//console.log("url==>",url);
	if (url.indexOf("http") != -1) {
		window.open(url);
	} else {
		window.open('/service'+url);
	}
}

/**
 *获取字符串长度
 * @param str
 * @returns {number}
 */
function getStrLength(str){
	if(str ==='' || str === undefined || str ==null){
		return 0;
	}
	let realLength = 0, len = str.length, charCode = -1;
	for (let i = 0; i < len; i++) {
		charCode = str.charCodeAt(i);
		if (charCode >= 0 && charCode <= 128) realLength += 1;
		else realLength += 3;
	}
	return realLength;
}

/**
 * 判断登录超时
 * return date.getFullYear() + '/' + _format(date.getMonth() + 1) + '/' + _format(date.getDate()) + '-' +
			_format(date.getHours()) + ':' + _format(date.getMinutes());
 */
function isLoginTimeout () {
	let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser')) || {};
	let expireTime = ssessionLogin.expireTime || 0;
	const currentTime = new Date().getTime();
	// let date = new Date(expireTime);
	// console.log("expireTime为",date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() 
	// + " " + date.getHours() + ":" + date.getMinutes());
	if (expireTime-currentTime<0) {
		// console.log("utils判断登录已超时");
		return false;
	} else {
		return true;
	}
}
function GetStrQuery() {
	var params = location.search.substr(1);//这一条语句获取了包括问号开始到参数的最后，不包括前面的路径,去掉问号
	var pa = params.split("&");
	var queryStr = new Object();
    for(var i = 0; i < pa.length; i ++){
        queryStr[pa[i].split("=")[0]] = unescape(pa[i].split("=")[1]);
    }
	if(queryStr != null) return queryStr;
	return null;
}

export default {
	formatTime,
	formatLocation,
	dateUtils,
	getUuid,
	isPoneNumber,
	isIDCard,
	isEmail,
	isPassword,
	windowOpen,
	isLoginTimeout,
	GetStrQuery
}
